import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  ButtonGroup,
  Button,
  Dropdown
} from "react-bootstrap";
import {
  updateLeaveAward,
  addLeaveAwards,
  updateList,
  resetList,
  getALeaveAward,
  getLeaveAwardByECandSL,
  getLeaveAwardsByEmployee,
} from "../../3.Store/LeaveAwardsSlice";
import { postsearchText, getAEmployee, resetForm } from "../../3.Store/EmployeeSlice";
import { ThreeDots } from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getEntitle } from "../../3.Store/LeaveEntitlementSlice";
import { dismissEmployee } from "../../3.Store/EmployeeSlice";

const LeaveAwardForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [inputValue, setInputValue] = useState("");
  const employees = useSelector(state => state.EmployeeSlice.employees);
  const awardList = useSelector(state => state.LeaveAwardsSlice.awardList) || {};
  const employeeDetail = useSelector(state => state.EmployeeSlice.employeeDetail) || {};
  const entitlements = useSelector(state => state.LeaveEntitlementSlice.entitles) || [];
  const [loading, setLoading] = useState(false);
  const { employee, created, advanced, annual, hospitalization, maternity, paternity, medical, sick, special, effective_date, year } = awardList;
  
  const [selectedCategoryId, setSelectedCategoryId] = useState(employee?.employee_category?.id);
  const [selectedServiceLengthId, setSelectedServiceLengthId] = useState(employee?.service_length?.id);
  const [reselectSL, setReselectSL] = useState(false);
  
  const getSearchParamsFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const years = params.get('years');
    return { page, years };
  };

  console.log(employee);

  const { page, years } = getSearchParamsFromQuery();

  useEffect(() => {
    dispatch(getEntitle());
    setLoading(true);
    window.scrollTo(0, 0);
    if (id) {
      dispatch(getALeaveAward({id})).finally(() => {
        setLoading(false);
      });
    } else {
      dispatch(resetList());
      dispatch(resetForm());
      setLoading(false);
    }
  }, [id]);

  // Derive unique employee categories from leaveentitlement DB
  const employeeCategories = useMemo(() => {
    const map = new Map();
    entitlements.forEach(e => {
      if (e.employee_catagory?.id && !map.has(e.employee_catagory.id)) {
        map.set(e.employee_catagory.id, {
          id: e.employee_catagory.id,
          label: e.employee_catagory.description || e.employee_catagory.short_description,
        });
      }
    });
    return [...map.values()];
  }, [entitlements]);

  // Derive service lengths filtered by selected category from leaveentitlement DB
  const filteredServiceLengths = useMemo(() => {
    const map = new Map();
    entitlements
      .filter(e => e.employee_catagory?.id === selectedCategoryId)
      .forEach(e => {
        if (e.service_length?.id && !map.has(e.service_length.id)) {
          map.set(e.service_length.id, {
            id: e.service_length.id,
            label: e.service_length.description || e.service_length.short_description,
          });
        }
      });
    return [...map.values()];
  }, [entitlements, selectedCategoryId]);

  useEffect(() => {
    if (employee?.employee_category?.id) {
      setSelectedCategoryId(employee.employee_category.id);
    }
    if (employee?.service_length?.id) {
      setSelectedServiceLengthId(employee.service_length.id);
    }
  }, [employee]);
  
  useEffect(() => {
    if (inputValue && inputValue.length > 2) {
      const entity = { searchText: inputValue, active: 1}
      dispatch(postsearchText(entity));
    }
  }, [inputValue]);

  useEffect(() => {
    console.log(200, employeeDetail);
    if (!employeeDetail) return; // Prevent unnecessary updates
    
    // Check if the new employeeDetail is actually different
    if (awardList.employee?.id !== employeeDetail.id) {
      const entity = {
        ...awardList,
        employee: employeeDetail,
      };
      dispatch(updateList(entity));
    }
  }, [employeeDetail]); // Only runs when employeeDetail changes  

  const handleDropdownChange = (selectedOption) => {
    console.log(selectedOption.id);
    dispatch(getAEmployee({ id : selectedOption.id}));
  };

  // Function to get the EmployeeCategory type label
  const getEmployeeCategoryLabel = (value) => {
    const category = employeeCategories.find(c => c.id === value);
    return category ? category.label : "";
  };

  const handleDropdownEmployeeCategory = async (value) => {

    // if (awardList.employee?.employee_category?.id === "S" && value !== "S") {
    //   setReselectSL(true);
    // }
    // else {
    //   setReselectSL(false);
    // }

    const result = await Swal.fire({
      // title: "Are you sure?",
      text: `Change employee category to ${getEmployeeCategoryLabel(value)}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    });

    if (result.isConfirmed) {
      setLoading(true);  // start loading

      // Determine if we need to force reselect service length
      const prevCategory = awardList.employee?.employee_category?.id;
      const forceReselectSL = prevCategory === "S" && value !== "S";

      const updatedEmployee = {
        ...awardList.employee,
        employee_category: { id: value }, // only this field is changed
        date_joined: moment(employee.date_joined).format("YYYY-MM-DD")
      };
    
      const updatedAwardList = {
        ...awardList,
        employee_category: { id: value },
        employee: updatedEmployee
      };
      console.log(updatedEmployee)
      dispatch(updateList(updatedAwardList));

      // If "S" category selected, show alert, set all to 0, and skip further processing
      if (forceReselectSL || value === "S") {
        Swal.fire({
          icon: "info",
          title: "Please check the service length",
          text: "Please reselect a service length for this category.",
        });

        // Set all leave values to 0 if category is 'S'
        const entity = {
          ...updatedAwardList,
          annual: "0.0",
          advanced: "0.0",
          sick: "0.0",
          hospitalization: "0.0",
          maternity: "0.0",
          paternity: "0.0",
          special: "0.0",
          medical: "0.0"
        };

        // Update the list with zeroed values and stop loading
        dispatch(updateList(entity));
        setLoading(false);
        return;
      }

      try {
        // Step 1: Update employee
        const updated = await dispatch(dismissEmployee({ id: updatedEmployee.id, ...updatedEmployee })).unwrap();
        console.log("Employee updated:", updated);

        const leaveAward = await dispatch(getLeaveAwardsByEmployee({ id: updatedEmployee.id, year: years })).unwrap();
        console.log("Returned leave award:", leaveAward);

        if (leaveAward?.id) {
          navigate(`/LeaveAwardForm/${leaveAward.id}?page=${page}&years=${years}`);
        } else {
          Swal.fire("No leave award found", "Please update service length at the employee details page.", "warning");
          handleBtnBack();
        }
      
      } catch (error) {
        console.error("Error during update or fetching award:", error);
      } finally {
        setLoading(false);  // stop loading in all cases
      }         
    }
  };

  // Function to get the ServiceLength type label
  const getServiceLengthLabel = (value) => {
    const match = entitlements.find(e => e.service_length?.id === value);
    return match ? (match.service_length.description || match.service_length.short_description) : "";
  };

  const handleDropdownServiceLength = async (value) => {
    const result = await Swal.fire({
      // title: "Are you sure?",
      text: `Change service length to ${getServiceLengthLabel(value)}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    });

    if (result.isConfirmed) {
      setLoading(true);
      const updatedEmployee = {
        ...awardList.employee,
        service_length: { id:value }, // only this field is changed
        date_joined: moment(employee.date_joined).format("YYYY-MM-DD")
      };
    
      const updatedAwardList = {
        ...awardList,
        service_length2: { id:value },
        employee: updatedEmployee
      };
      console.log(updatedEmployee)
      console.log(updatedAwardList)
      dispatch(updateList(updatedAwardList));

      try {
        // Step 1: Update employee
        const updated = await dispatch(dismissEmployee({ id: updatedEmployee.id, ...updatedEmployee })).unwrap();
        console.log("Employee updated:", updated);

        const leaveAward = await dispatch(getLeaveAwardsByEmployee({ id: updatedEmployee.id, year: years })).unwrap();
        console.log("Returned leave award:", leaveAward);

        if (leaveAward?.id) {
          navigate(`/LeaveAwardForm/${leaveAward.id}?page=${page}&years=${years}`);
        } else {
          Swal.fire("No leave award found", "Please check the record manually.", "warning");
        }
      } catch (error) {
        console.error("Error during update or fetching award:", error);
      } finally {
        setLoading(false);  // stop loading in all cases
      }         
    }
  };

  const handleBtnSave = () => {
    const entity = { ...awardList };
    setLoading(true);
    dispatch(addLeaveAwards(entity))
      .unwrap()
      .then(() => {
        Swal.fire("Record Added", "", "success").then(() => {
          navigate(`/LeaveAwardList`);
        });
      })
      .catch((err) => {
        Swal.fire("Error", err.message, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };  

  const handleUpdate = (e) => {
    const entity = { ...awardList, [e.target.name]: e.target.value };
    dispatch(updateList(entity));
  };

  const handleBtnUpdate = () => {
    // Check if the selected year is the current year
    // const currentYear = new Date().getFullYear();
    // console.log(currentYear, years);
    // if (parseInt(years) !== currentYear) {
    //   // If not the current year, show the Swal popup
    //   Swal.fire({
    //     title: "You are editing awards for year " + years,
    //     text: "Confirm to update?",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "Yes",
    //     cancelButtonText: "No",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       // Proceed with updating if the user confirmed
    //       submitUpdate();
    //     }
    //   });
    // } else {
    //   // Proceed with the update if the year is the current year
    //   submitUpdate();
    // }
    const entity = { ...awardList, employee_category: { id: selectedCategoryId }, service_length2: { id: selectedServiceLengthId} };
    setLoading(true);
    dispatch(updateLeaveAward(entity))
      .unwrap()
      .then(() => {
        Swal.fire("Record Updated", "", "success").then(() => {
          navigate(`/LeaveAwardForm/${id}?page=${page}&years=${years}`);
        });
      })
      .catch((err) => {
        Swal.fire("Error", err.message, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  const handleBtnBack = () => {
    dispatch(resetList());
    dispatch(resetForm());
    // navigate("/LeaveAwardList");
    navigate(`/LeaveAwardList?page=${page}&years=${years}`);
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Leave Award {years}</h1>
        <h1 className="MiniTitleHeader">Employee</h1>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">FullName</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                {!id ? (
                  <Select
                    inputValue={inputValue}
                    onInputChange={(value) => setInputValue(value)}
                    name="employee"
                    onChange={handleDropdownChange}
                    options={employees.map(employee => ({ label: employee.fullname, value: employee.fullname, id: employee.id }))}
                    placeholder="Select Employee"
                  />
                ) : (
                  <Form.Control value={employee?.fullname} readOnly disabled/>
                )}
              </Col>
            </Row>
          </Col>
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Date Joined</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={moment(employee?.date_joined).format("YYYY-MM-DD")} readOnly disabled/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Staff ID</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={employee?.sid} readOnly disabled/>
              </Col>
            </Row>
          </Col>
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Company</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={employee?.company?.description} readOnly disabled/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Employee Category</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Dropdown>
                  <Dropdown.Toggle className="Button" style={{width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{getEmployeeCategoryLabel(selectedCategoryId)}</Dropdown.Toggle>
                  <Dropdown.Menu style={{ width: "100%" }}>
                    {employeeCategories.map((cat) => (
                      <Dropdown.Item key={cat.id} onClick={() => handleDropdownEmployeeCategory(cat.id)}>
                        {cat.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
          </Col>
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Service Length</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Dropdown>
                  <Dropdown.Toggle className="Button" style={{ width: "100%" }}>
                    {getServiceLengthLabel(selectedServiceLengthId)?.toUpperCase()}
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ width: "100%" }}>
                    {filteredServiceLengths.map((length) => (
                      <Dropdown.Item key={length.id} onClick={() => handleDropdownServiceLength(length.id)}>
                        {length.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
          </Col>
        </Row>

        {!id && (
          <Row className="my-3">
            <Col md={4} sm={4}>
              <Form.Label className="FormLabel fw-normal fs-5">Year</Form.Label>
            </Col>
            <Col md={8} sm={8}>
              <Form.Control name="year" value={year} onChange={handleUpdate} />
            </Col>
          </Row>
        )}
        
        <Row className="my-3">
          <Col md={4} sm={4}>
            <Form.Label className="FormLabel fw-normal fs-5">Effective Date</Form.Label>
          </Col>
          <Col md={8} sm={8}>
            {/* {!id ? (
              <Form.Control type="date" name="effective_date" value={moment(effective_date).format("YYYY-MM-DD")} onChange={handleUpdate}/>
            ) : (
              <Form.Control value={moment(created).format("YYYY-MM-DD")} readOnly />
            )} */}
            {!id ? (
              <DatePicker
                selected={effective_date ? new Date(effective_date) : null}
                onChange={(date) =>
                  handleUpdate({
                    target: {
                      name: "effective_date",
                      value: moment(date).format("YYYY-MM-DD"),
                    },
                  })
                }
                dateFormat="yyyy-MM-dd"
                className="form-control w-100 datepicker-icon"
              />
            ) : (
              <Form.Control value={moment(effective_date).format("YYYY-MM-DD")} readOnly disabled/>
            )}
          </Col>
        </Row>

        {[
          { label: "Annual", name: "annual", value: annual },
          { label: "Advanced", name: "advanced", value: advanced },
          { label: "Sick", name: "sick", value: sick },
          { label: "Hospitalization", name: "hospitalization", value: hospitalization },
          { label: "Maternity", name: "maternity", value: maternity },
          { label: "Paternity", name: "paternity", value: paternity },
          { label: "Special", name: "special", value: special },
          { label: "Medical", name: "medical", value: medical },
        ].map((field, index) => (
          <Row className="my-3" key={index}>
            <Col md={4} sm={4}>
              <Form.Label className="FormLabel fw-normal fs-5">{field.label}</Form.Label>
            </Col>
            <Col md={8} sm={8}>
              <Form.Control type="number" name={field.name} value={field.value} onChange={handleUpdate} />
            </Col>
          </Row>
        ))}

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          {!id ? (
            <ButtonGroup className="my-2">
              <Button className="Button" onClick={handleBtnSave}>
                Save
              </Button>
            </ButtonGroup>
          ):(
            <ButtonGroup className="my-2">
              <Button className="Button" onClick={handleBtnUpdate}>
                Update
              </Button>
            </ButtonGroup>
          )}
        </div>
      </Card>
    </Container>
  );
};

export default LeaveAwardForm;